<template>
  <span :aria-hidden="decorative"
        :aria-label="title"
        class="material-design-icon account-icon"
        role="img">

    <!-- <svg :fill="fillColor"
         class="material-design-icon__svg"
         :width="size"
         :height="size"
         viewBox="0 0 24 24">
      <path d="M12,4C14.21,4 16,5.79 16,8C16,10.21 14.21,12 12,12C9.79,12 8,10.21 8,8C8,5.79 9.79,4 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z">
        <title>{{ title }}</title>
      </path>
    </svg> -->

    <svg class="material-design-icon__svg" xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="29.5 28 24.764 31.621"><g :fill="fillColor"><path d="M42.605 59.62c-3.52-.005-6.288-.269-8.945-1.2-.84-.295-1.654-.712-2.416-1.178-1.327-.814-1.886-2.025-1.714-3.602.521-4.76 2.83-8.309 7.181-10.357 6.991-3.29 15.132.609 17.126 8.148.234.89.314 1.826.41 2.746.117 1.153-.432 2.037-1.282 2.746-1.233 1.026-2.714 1.536-4.24 1.92-2.243.567-4.528.791-6.12.777M48.463 34.571c.006 3.641-2.947 6.604-6.582 6.602-3.621-.001-6.602-2.988-6.592-6.606.01-3.622 2.946-6.554 6.576-6.567a6.564 6.564 0 016.598 6.571"/></g></svg>

  </span>
</template>

<script>
export default {
  name: "PersonalDataIcon",
  props: {
    title: {
      type: String,
      default: "Personal Data icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
}
</script>
